/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".data-selected{background-color:var(--background-data-selected)!important;color:var(--foreground-data-selected)!important}"];
export { styles as styles };
